/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
import { OMT_UI_AvatarWithFrame } from './OMT_UI_AvatarWithFrame';

/*
  generic friends list item / row
*/
export class OMT_UI_FriendsListItem extends Phaser.Group {
  /**
   * constructor
   * @param {Object} friendData
   * @param {number} itemWidth
   * @param {number} itemHeight
   * @param {number} bgColor
   */
  constructor(friendData, itemWidth, itemHeight, bgColor) {
    super(game);

    this.signals = {}; // add signals to this

    this._friendData = friendData;
    this._itemWidth = itemWidth;
    this._itemHeight = itemHeight;

    // calculate positions based on itemWidth / itemHeight
    this._imageSize = Math.round(this._itemHeight * 0.85);
    this._imageX = Math.round(this._itemHeight * 0.1) + Math.round(this._imageSize / 2);
    this._nameLabelX = this._imageX + (this._imageSize / 2) + 10;
    this._nameLabelFontSize = `${Math.round(this._itemHeight * 0.5)}px`;
    this._buttonRightX = this._itemWidth;
    this._buttonHeight = Math.round(this._itemHeight * 0.8);

    this._drawBackground(bgColor);
    this._initAvatar();
    this._initNameLabel();
  }

  /**
   * get the relevant friend data Obejct
   * @returns {Object}
   */
  get friendData() {
    return this._friendData;
  }

  /**
   * draw the items background
   */
  _drawBackground(bgColor) {
    const graphics = new Phaser.Graphics(game);
    graphics.beginFill(bgColor);
    graphics.drawRect(0, 0, this._itemWidth, this._itemHeight);
    graphics.endFill();
    this.addChildAt(graphics, 0);
  }

  /**
   * init the avatar image
   * @param {string} imageUrl
   */
  _initAvatar() {
    this._avatarImage = new OMT_UI_AvatarWithFrame(this._friendData.image, this._imageSize);
    this._avatarImage.x = this._imageX;
    this._avatarImage.y = this._itemHeight / 2;
    this.addChild(this._avatarImage);
  }

  /**
   * init the users name label
   */
  _initNameLabel() {
    const style = { style: 'font-blue', fontSize: this._nameLabelFontSize, align: 'left' };
    this._nameLabel = new G.Text(0, 0, this._shortenName(this._friendData.name), style, [0, 0.5], 500, this._itemHeight, true);
    this._nameLabel.x = this._avatarImage.x + (this._imageSize / 2) + 10;
    this._nameLabel.y = this._itemHeight / 2;
    this.addChild(this._nameLabel);
  }

  /**
   * shorten the users name
   * @param {string} fullName
   * @param {number} maxLength
   */
  _shortenName(fullName, maxLength = 13) {
    if (fullName.length > maxLength && fullName.length > 3) {
      fullName = `${fullName.substr(0, maxLength - 3)}...`;
    }
    return fullName;
  }

  /**
   * main update method
   */
  update() {
    //
  }
}
